'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitForConnection = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _timeout = require('q/js/lib/timeout');

var _timeout2 = _interopRequireDefault(_timeout);

var _defaults = require('../constants/defaults');

var _statusChangeToError = require('../operators/statusChangeToError');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var waitForConnection = exports.waitForConnection = function waitForConnection(connection) {
  return (0, _timeout2.default)(new _q2.default.Promise(function (resolve, reject) {
    connection.once('connected', resolve);
    connection.once('failed', function (statusChange) {
      return reject((0, _statusChangeToError.statusChangeToError)('PubSub connection failed', statusChange));
    });
  }), _defaults.PROMISE_TIMEOUT_MS, 'PubSub wait for connection timeout');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/waitForConnection.js
// module id = 778
// module chunks = 2 3